__turbopack_context__.v({
  "buttonsContainer": "callFormSteps-module-scss-module__48mDiq__buttonsContainer",
  "callDetailsFieldsContainer": "callFormSteps-module-scss-module__48mDiq__callDetailsFieldsContainer",
  "contactUsLabel": "callFormSteps-module-scss-module__48mDiq__contactUsLabel",
  "dialInCountriesContainerCls": "callFormSteps-module-scss-module__48mDiq__dialInCountriesContainerCls",
  "formSectionSubtitle": "callFormSteps-module-scss-module__48mDiq__formSectionSubtitle",
  "formSectionTitleSettings": "callFormSteps-module-scss-module__48mDiq__formSectionTitleSettings",
  "inputWrapper": "callFormSteps-module-scss-module__48mDiq__inputWrapper",
  "landingTableTitle": "callFormSteps-module-scss-module__48mDiq__landingTableTitle",
  "smallInput": "callFormSteps-module-scss-module__48mDiq__smallInput",
  "stepHeaderTitle": "callFormSteps-module-scss-module__48mDiq__stepHeaderTitle",
  "stepNavigationBtn": "callFormSteps-module-scss-module__48mDiq__stepNavigationBtn",
  "submitWrapper": "callFormSteps-module-scss-module__48mDiq__submitWrapper",
  "subtitleLink": "callFormSteps-module-scss-module__48mDiq__subtitleLink",
});
